// covered-by: qa/rickrubin/tests/specs/cca/ask.puntt.sidebar.nav.spec.ts
// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import AskPunttHome from "./home";

import PendingComponent from "../../components/PendingComponent";
import { canAccessAskPuntt } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export const askPunttRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt",
  beforeLoad() {
    if (!canAccessAskPuntt()) {
      throw redirect({ to: ticketsRoute.to });
    }
  },
  component: AskPunttHome,
  pendingComponent: PendingComponent,
  gcTime: 0,
  // Re-run the access guard on every navigation so a user who lost Ask Puntt
  // access mid-session (enterprise toggle OFF) cannot revisit a cached route.
  shouldReload: true,
  pendingMs: 0,
  pendingMinMs: 500,
});
